import React from "react";
import { motion } from "framer-motion";
import { Mic, Music, Music3, Sliders, Disc3, Building2, Speaker, Clapperboard, User, Headphones } from "lucide-react";

const AUDIENCES = [
  { Icon: Mic, label: "خواننده‌ها" },
  { Icon: Music3, label: "رپرها" },
  { Icon: Music, label: "آهنگسازها" },
  { Icon: Sliders, label: "تنظیم‌کننده‌ها" },
  { Icon: Disc3, label: "تهیه‌کننده‌های موسیقی" },
  { Icon: Building2, label: "لیبل‌های موسیقی" },
  { Icon: Speaker, label: "استودیوهای ضبط" },
  { Icon: Clapperboard, label: "تولیدکنندگان موزیک‌ویدیو" },
  { Icon: User, label: "هنرمندان مستقل" },
  { Icon: Headphones, label: "مدیر برنامه‌های هنرمندان" },
];

export default function WhoFor() {
  return (
    <section className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <h2 className="mt-2 text-3xl md:text-4xl font-bold tracking-tight">
            این سرویس برای <span className="gradient-text-neon">چه کسانی</span> مناسب است؟
          </h2>
          <p className="mt-5 text-slate-300 leading-relaxed">
            اگر اثری آماده انتشار دارید یا می‌خواهید درآمد موزیک‌های منتشرشده خود را از پلتفرم‌های جهانی دریافت کنید،
            این سرویس برای شما طراحی شده است.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {AUDIENCES.map((a, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              className="glass glass-hover rounded-2xl p-5 flex flex-col items-center text-center transition-all"
              data-testid={`audience-${i}`}
            >
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500/20 to-cyan-400/20 border border-white/10 flex items-center justify-center mb-3">
                <a.Icon className="w-5 h-5 text-cyan-200" strokeWidth={1.6} />
              </div>
              <span className="text-sm font-medium text-slate-200">{a.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
